import React from 'react';
import cx from 'classnames';

import {
  activeTourStepSelector,
  completedTourStepsSelector,
} from 'redux/selectors/onboardingSelectors';
import { TourStepEnum } from 'features/onboarding/enums';
import { useAppSelector } from 'hooks/useAppSelector';

import styles from './TourProgress.module.less';

type Props = {
  className?: string;
};

const PROGRESS_STEPS = [
  TourStepEnum.AccountSettings,
  TourStepEnum.Sidebar,
  TourStepEnum.HomeDashboard,
];

export default function TourProgress(props: Props) {
  const { className } = props;
  const completedTourSteps = useAppSelector(completedTourStepsSelector);
  const activeTourStep = useAppSelector(activeTourStepSelector);

  return (
    <div className={cx(styles.tourProgress, className)}>
      {PROGRESS_STEPS.map((step, index) => (
        <div key={`${step}-${index}`} className={styles.progressItem}>
          <div
            className={cx(styles.progressBg, {
              [styles.active]: activeTourStep === step,
              [styles.completed]: completedTourSteps.includes(step),
            })}
          />
        </div>
      )).reverse()}
    </div>
  );
}
